import React from 'react';

import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useLocation } from 'react-router-dom';

import { Header } from '../../components/Header';
import { Loader } from '../../components/Loader';
import { LearnerInfo } from '../../types';
import { Manager } from './components/Manager';
import { User } from './components/User';
import useStyles from './styles';

interface AssignedLearningPageProps {
  userInfo: LearnerInfo;
  title?: string;
  tenantTitle?: string | null;
  tenantName?: string | null;
}

const AssignedLearningPage: React.FC<AssignedLearningPageProps> = ({
  userInfo,
  title,
  tenantTitle,
  tenantName,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const location = useLocation();
  const isManagerDashboard = location?.pathname.includes('/assigned-learning/dashboard');

  const assignedTitle = title || t('page.assignedLearnings.assigned');

  return (
    <div className={classes.wrapper}>
      <Header
        title={`${assignedTitle} ${t('page.assignedLearnings.learning')}`}
        wrapperClass={classes.headerWrapper}
        contentWrapperClass={classes.headerContainer}
        titleClass={classes.headerTitle}
        tenantName={tenantName}
      >
        <Container>
          <Typography className={classes.headerDescription}>
            {t(
              isManagerDashboard
                ? 'page.assignedLearnings.learningManagerDesc'
                : 'page.assignedLearnings.learningLearnerDesc',
            )}
          </Typography>
        </Container>
      </Header>
      <Switch>
        {userInfo?.is_manager && (
          <Route
            path="/assigned-learning/dashboard"
            render={(props) => (
              <Manager
                tenantTitle={tenantTitle}
                companyId={userInfo?.company?.id}
                fallback={<Loader />}
                {...props}
              />
            )}
          />
        )}
        <Route
          path="/assigned-learning"
          render={(props) => (
            <User
              tenantTitle={tenantTitle}
              tenantName={tenantName}
              {...props}
              userId={userInfo?.id}
              isManager={userInfo?.is_manager}
              fallback={<Loader />}
            />
          )}
        />
      </Switch>
    </div>
  );
};

export default AssignedLearningPage;
